<template>
    <footer>
        <div class="footer">
            <div class="col1">
                <p>
                    Copyright © 2020 LG lugar de gente - Todos os direitos
                    reservados.
                </p>
            </div>
            <div class="col2">
                <a
                    class="ico lg"
                    href="https://www.lg.com.br/"
                    target="_blank"
                ></a>
                <a
                    class="ico lgpd"
                    href="https://www.lg.com.br/lps/agende-uma-visita/"
                    target="_blank"
                ></a>
            </div>
        </div>
        <div class="yellowBar"></div>
    </footer>
</template>
<script>
export default {
    data() {
        return {};
    },
    methods: {},
    created() {},
    mounted() {},
};
</script>
<style lang="scss" scoped>
.footer{
    padding-top: 20px;
    padding-bottom: 20px;
    position: relative;
    display: flex;
    // justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    max-width: 1366px;
    width: 100%;
    // height: 100px;
}
.ico{
    height: 60px;
    width:60px;
    padding: 0 10px 0 10px;
    background-size: contain;
    background-repeat: no-repeat;
}
.col1{
    width: 556px;
    padding-top: 9px;
    font-size: 0.8rem;
}
.col2{
    display: flex;
    justify-content: center;
    align-items: flex-start;
    margin-left: auto;
}
.yellowBar{
    // margin-top: 10px;
    height: 10px;
    width: 100%;
    background-color: $color-yellow;
}

.lg{
    background-image: url("~@/assets/img/page16-ico1.png") ;
    height:49px;
    width: 168px;
}
.lgpd {
    background-image: url("~@/assets/img/page16-ico0.png");
}
@media (max-width: 900px) {
    .col1 {
        width: 90%;
    }
    .col2 {
        flex-wrap: wrap;
        padding-top: 30px;
        margin: 0 auto;
    }
    .footer {
        flex-direction: column;
        padding-top: 20px;
        padding-bottom: 20px;
    }
}
@media (max-width: 500px) {
    .col2 {
        flex-wrap: wrap;
        padding-top: 30px;
    }
}
</style>